var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.207006 0.290326L0.274405 0.219668C0.566469 -0.050692 1.02603 -0.0714895 1.34386 0.157276L1.42019 0.219668L6.51859 4.93875L11.617 0.219668C11.9334 -0.073222 12.4464 -0.073222 12.7628 0.219668C13.0792 0.512566 13.0792 0.987436 12.7628 1.28033L7.66501 6L12.7628 10.7197C13.0548 10.9901 13.0773 11.4155 12.8302 11.7097L12.7628 11.7803C12.4707 12.0507 12.0112 12.0715 11.6933 11.8427L11.617 11.7803L6.51859 7.06125L1.42019 11.7803C1.10378 12.0732 0.590807 12.0732 0.274405 11.7803C-0.0419885 11.4875 -0.0419885 11.0126 0.274405 10.7197L5.37218 6L0.274405 1.28033C-0.0176505 1.00997 -0.0401169 0.584543 0.207006 0.290326L0.274405 0.219668L0.207006 0.290326Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXGray);
export default __webpack_public_path__ + "static/media/x_gray.bd0a6f2d1b75093d267c83d5e958aa01.svg";
export { ForwardRef as ReactComponent };